<template>
    <div class="panel-list">
        <h3>
            {{ title }}
        </h3>
        <p>
            {{ description }}
        </p>

        <div class="paginate" v-if="to < total">
            <span>{{ `${from} - ${to} of ${total}`}}</span>
            <button @click="!isLoading ? $emit('prev') : null" :disabled="from === 1"></button>
            <button @click="!isLoading ? $emit('next') : null" :disabled="to === total"></button>
        </div>

		<AppLoading
            class="loading"
            v-if="isLoading"
        ></AppLoading>

        <div class="table-wrapper" v-else>
            <table>
                <tr
                    v-for="(item, index) in items"
                    :key="index"
                >
                    <td
                        v-for="(field, index) in fields"
                        :key="index"
                    >
                        <slot
                            :name="field"
                            :item="item"
                        >
                            {{ item[field] }}
                        </slot>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: ''
		},

		description: {
			type: String,
			default: ''
		},

		items: {
			type: Array,
			required: true
		},

		fields: {
			type: Array,
			required: true
		},

		to: {
			type: [Number, String],
			default: 0
		},

		from: {
			type: [Number, String],
			default: 0
		},

		total: {
			type: [Number, String],
			default: 0
		},

		isLoading: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scope>
.panel-list {
    width: 400px;
    height: 100%;
    display: flex;
    flex-direction: column;

    h3, p , .paginate {
        padding: 0 15px;
    }

    h3 {
        margin-top: 20px;
        margin-bottom: 10px;
    }

    p {
        margin-bottom: 20px;
        font-style: italic;
    }

	.loading {
		margin: 50px auto;
	}

    table {
        table-layout: fixed;
        width: 100%;
        border-collapse: collapse;

        tr {
            border: 1px solid $light;

            &:nth-child(even) {
                background-color: $light2;
            }
        }

        td {
            padding: 10px 15px;
        }
    }

    .table-wrapper {
        flex: 1 1 auto;
        margin-bottom: 20px;
        width: 100%;
        overflow: auto;
    }

    .paginate {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;

        font-size: .8rem;

        button {
            padding: 4px;
            width: 25px;
            margin-left: .5rem;
            cursor: pointer;
            border: 1px solid #aaa;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;

            &:disabled {
                opacity: 0.5;
                pointer-events: none;
            }

            &:before {
                content: '';
                display: inline-block;
                width: 5px;
                height: 5px;
                border: 1px solid;
                border-color: #aaa transparent transparent #aaa;
                transform: rotateZ(-45deg);
            }

            &:last-child {
                transform: scale(-1);
            }
        }
    }

    .loading {
        margin: 50px auto;
    }
}
</style>
